export const tr = {
    'invalid-query':
        'Sözcük grubu geçersiz karakterler içeriyor. Yalnızca harfler, rakamlar ve Yandex.Direct operatörleri kullanılabilir.',
    'no-phrases-for-dynamic-campaigns': 'Dinamik kampanya gruplarına sözcük grupları eklenemez',
    'no-phrases-for-smart-banners': "Akıllı banner'lara sözcük grupları eklenemez"
};
